import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { formatMessage } from '../../../../translations/format-message';
import { useFormikContext } from 'formik';
import { chunkArray } from '../../../../helpers/array-to-tree-helper';
import { useStore } from '../../../../contexts/store-provider';

interface IProps {
  values: any;
  setSelectedProcessId: Dispatch<SetStateAction<number>>;
  selectedProcessId: number;
  id: number;
}

const CommonProcessTabView = (props: IProps) => {
  const { setFieldValue } = useFormikContext<any>();
  const { values, setSelectedProcessId, selectedProcessId, id } = props;
  const { teplarPrintStore } = useStore();
  const { teplarDetailsList } = teplarPrintStore;
  const tabList = [
    {
      Id: -3,
      Title: 'common',
    },
    {
      Id: -4,
      Title: 'dimension_table',
    },
  ];

  useEffect(() => {
    // Only auto-populate Teplars from the matched CSV template when this product
    // genuinely has none yet. Without this guard, this effect re-fires every time
    // Step 3 (Common Tabs) remounts - e.g. navigating Step 4 -> back to Step 3 -> forward
    // again - and unconditionally overwrites ProductTeplars with whatever
    // teplarDetailsList currently holds (often simply [], since teplarDetailsList
    // defaults to an empty array, which is still truthy), silently wiping out any
    // Teplar rows the user already typed manually on Step 4.
    const alreadyHasTeplars =
      Array.isArray(values?.ProductTeplars) && values.ProductTeplars.length > 0;
    if (alreadyHasTeplars) return;

    if (Array.isArray(teplarDetailsList) && teplarDetailsList.length > 0 && props.id < 0) {
      const teplarDetailsArr: any[] = [];
      teplarDetailsList.forEach((item) => {
        const layouts = teplarDetailsList.map((t) => t.Layout);
        const fallbackColumnCount = layouts.length > 0 ? Math.max(...layouts) : 1;
        const columnCount =
          Number(item?.Layout || 0) > 0 ? Number(item.Layout) : fallbackColumnCount;
        const chunkedItems = chunkArray(item.Items, columnCount);
        const transformedChunks = chunkedItems.map(
          (filteredItem, chunkIndex) => ({
            Id: chunkIndex === 0 ? (item.Id || 0) : 0,
            Format: item.Format,
            Layout: item.Layout,
            Width: item.Width,
            Items: filteredItem.join(','),
            Position: '',
            Remarks: '',
          })
        );
        teplarDetailsArr.push(...transformedChunks);
      });

      setFieldValue('ProductTeplars', [...teplarDetailsArr]);
    }
  }, [teplarDetailsList, props.id, setFieldValue, values?.ProductTeplars]);

  return (
    <ul
      className="nav nav-tabs"
      id="processTab"
      role="tablist"
    >
      {tabList.map((proc) => (
        <li
          className={`nav-item ${proc?.Id == selectedProcessId ? 'active' : ''}`}
          role="presentation"
        >
          <button
            className={`nav-link ${proc?.Id == selectedProcessId ? 'active' : ''}`}
            id="home-tab"
            data-bs-toggle="tab"
            data-bs-target="#home"
            type="button"
            role="tab"
            aria-controls="home"
            aria-selected="true"
            onClick={() => setSelectedProcessId(proc.Id)}
          >
            {formatMessage(proc.Title)}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default CommonProcessTabView;
